/**
 * House/room sections for tagging portfolio images and design submission (iteration) images.
 * Used in AddPortfolio and DesignSubmissionModal for category tagging;
 * display order used when showing media by section in LeadRequestDetails and RequestDetails.
 */
export const HOUSE_SECTIONS = [
  'Hall',
  'Kitchen',
  'Master Bedroom',
  'Bedroom',
  'Balcony',
  'Bathroom',
  'Dining Room',
  'Living Room',
  'Study Room',
  'Kids Room',
  'Pooja Room',
  'Store Room',
  'Other',
];
